import React from 'react';
import styles from './styles/XImageLink.module.scss';

export interface IImageLinkProps {
    source?: string;
    reference?: string;
    text?: string;
    padding?: string;
    //children? :JSX.Element[];
    //name:string;
    //optionalParam?:number;
}
export interface IImageLinkState {

}
export class XImageLink extends React.Component<IImageLinkProps, IImageLinkState> {
    // constructor(props: IImageLinkProps) {
    //     super(props)
    // }
    render() :React.ReactNode
    {
        return <a href={this.props.reference} className={styles.XImageLink} style={{padding: this.props.padding}}><img src={this.props.source} alt={this.props.text}/></a>
    }
}

//export default {Application};